import { toast } from 'react-hot-toast';

// Ref. documentation: https://react-hot-toast.com/
export const useToast = () => {
    const toastSuccess = (text: string) => {
        toast.success(text, { duration: 4000 });
    };
    const toastError = (text: string, duration?: number) => {
        if (duration) {
            toast.error(text, { duration });
        } else {
            toast.error(text);
        }
    };
    return { toastSuccess, toastError };
};
